import { render, staticRenderFns } from "./ProductStandard2.vue?vue&type=template&id=cba1f568&scoped=true"
import script from "./ProductStandard2.vue?vue&type=script&lang=js"
export * from "./ProductStandard2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba1f568",
  null
  
)

export default component.exports